import clsx from "clsx";
import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colorSystem } from "../../theme";
import { tableStyles } from "./tableStyle";

const useStyles = makeStyles((theme) => ({
  tableHeader: {
    backgroundColor: colorSystem.white2,
    padding: theme.spacing(2, 1),
  },

  tableHeaderText: {
    color: colorSystem.gray,
    fontSize: 14,
    fontWeight: 700,
  },

  flex: {
    display: "flex",
  },

  comments: {
    paddingLeft: theme.spacing(1),
  },
}));

interface ClientNutritionEntriesListTableHeaderProps {
  showAdvancedNutrition: boolean;
}

export function ClientNutritionEntriesListTableHeader(
  props: ClientNutritionEntriesListTableHeaderProps,
) {
  const { showAdvancedNutrition } = props;
  const t = tableStyles();
  const s = useStyles();

  return (
    <Box className={clsx(s.flex, s.tableHeader)}>
      <Box className={t.tableTarget}>
        <Typography
          variant="body1"
          children="Date"
          className={s.tableHeaderText}
        />
      </Box>
      <Box className={t.tableProtein}>
        <Typography
          variant="body1"
          children="Protein"
          className={s.tableHeaderText}
        />
      </Box>
      <Box className={t.tableCarbs}>
        <Typography
          variant="body1"
          children="Carbs"
          className={s.tableHeaderText}
        />
      </Box>
      <Box className={t.tableFat}>
        <Typography
          variant="body1"
          children="Fat"
          className={s.tableHeaderText}
        />
      </Box>
      <Box className={t.tableCalories}>
        <Typography
          variant="body1"
          children="Kcal"
          className={s.tableHeaderText}
        />
      </Box>
      {showAdvancedNutrition && (
        <>
          <Divider sx={{ height: 20, ml: 2, mr: 5 }} orientation="vertical" />
          <Box className={t.tableCalories}>
            <Typography
              variant="body1"
              children="Alcohol"
              className={s.tableHeaderText}
            />
          </Box>
          <Box className={t.tableTarget}>
            <Typography
              variant="body1"
              children="Cholesterol"
              className={s.tableHeaderText}
            />
          </Box>
          <Box className={t.tableCalories}>
            <Typography
              variant="body1"
              children="Fiber"
              className={s.tableHeaderText}
            />
          </Box>
          <Box className={t.tableCalories}>
            <Typography
              variant="body1"
              children="Sodium"
              className={s.tableHeaderText}
            />
          </Box>
          <Box className={t.tableCalories}>
            <Typography
              variant="body1"
              children="Sugar"
              className={s.tableHeaderText}
            />
          </Box>
          <Box className={t.tableCalories}>
            <Typography
              variant="body1"
              children="Trans fat"
              className={s.tableHeaderText}
            />
          </Box>
        </>
      )}
    </Box>
  );
}
